export default __webpack_public_path__ + "static/media/sec313.08cc7740.jpeg";